export default __webpack_public_path__ + "static/media/hailoffuriousstrikes2.43c7725b.png";